import { Pipe, PipeTransform } from '@angular/core';
import { ISelectOption } from 'src/app/interfaces/select.interfaces';

@Pipe({
    name: 'isChipSelected',
    standalone: false
})
export class IsChipSelectedPipe implements PipeTransform {
    public transform(chip: ISelectOption, values: ISelectOption[]): any {
        return !!values.find((c) => c.value === chip.value && c.selected);
    }
}
